import { Link } from 'react-router';
import React from 'react';
import PropTypes from 'prop-types';

const ReportHeader = ({
  title,
}) => {
  return (
    <React.Fragment>
      <h2>{title}</h2>
      <p>
        Your {title} jobs will be available&nbsp;
        <Link to='/setup/user_jobs'>here</Link>.
      </p>
    </React.Fragment>
  )
}

ReportHeader.propTypes = {
  title: PropTypes.string.isRequired,
}

export default ReportHeader;
